<template>
  <div class="tabs">
    <div class="tabs-header">
      <div class="tabs-header-border">
        <div class="tabs-header-layout">
          <router-link
            v-for="(item, index) in tabs"
            :key="index"
            :to="item.route"
            class="tab-item"
            replace
            :data-qa="
              `tab-${item.route.name
                .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
                .toLowerCase()}`
            "
          >
            {{ item.title }}
          </router-link>
        </div>
      </div>
    </div>

    <div class="tabs-content">
      <div class="tabs-content-layout">
        <slot name="router">
          <router-view></router-view>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageTabs',

  props: {
    tabs: {
      type: Array,
      required: false
    }
  }
}
</script>

<style scoped>
.tabs-header {
  background: #f2f5f9;
  overflow-x: auto;
}

.tabs-header-border {
  border-bottom: 1px solid #e5e5e5;
  padding: 0 22px;
}

.tabs-header-layout {
  display: flex;
  margin: 0 auto;
  height: 40px;
}

.tab-item {
  cursor: pointer;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  color: #7e8596;
}

.tab-item.router-link-active {
  color: #1d87c8;
  background-color: #ffffff;
  border: 1px solid #e5e5e5;
  border-bottom: 0 none;
  border-radius: 4px 4px 0 0;
  margin-bottom: -1px;
}

.tabs-content {
  background: #ffffff;
}

.tabs-content-layout {
  padding: 22px;
  margin: 0 auto;
}

.tabs-content-layout >>> .page-ct {
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/common/components/page/PageTabs.vue